import type { IconFieldDesignTokens } from '@primeuix/themes/types/iconfield'

export default {
    icon: {
        color: '{form.field.icon.color}',
    },
} satisfies IconFieldDesignTokens
